
export const titleMap = {
    "grant_type": "Grant type",
    "center_name": "Center",
    "lab_name": "Lab",
    "data_type": "Data Type",
    "experiment_category": "Experiment Category",
    "experiment_type": "Experiment Type",
    "in_production_stage_standardized_protocol": "In \"production stage\"",
    "important_to_be_made_available": "One-off Availability Important",
    "reference_publication": "Reference Publication with Similar Data Type",
    "experiments_expected_2017"     : "2017 Experiments expected",
    "experiments_expected_2020": "2020 Experiments expected",
    "raw_files_size": "Raw filesize for 1 experiment (Gb)",
    "raw_files_widely_useful": "Raw files will be widely useful to the general community",
    "raw_files_keep_archived": "Raw files kept for possible future access?",
    "processed_files_size": "Processed filesize for 1 experiment (Gb)",
    "dockerized_software_exists": "Dockerized Opensource Software",
    "additional_comments": "Additional comments"
}

export const titleMapOlder = {
    "grant_type": "Grant type",
    "center_name": "Lab",
    "lab_name": "Lab PI",
    "data_type": "Data Type",
    "experiment_category": "Experiment Category",
    "experiment_type": "Experiment Type",
    "in_production_stage_standardized_protocol": "is this an experiment type that is in \"production stage\"; will be applied with a standardized protocol to different samples/cell types/regions?",
    "important_to_be_made_available": "if this is a one-off experiment for a technology development project, do you still think the data is important to be made readily available to the general community in the coming years? (Answer no if you plan to generate superseding data in the 1-2 following years.)",
    "reference_publication": "Reference publication with same/similar data type to guide metadata schema development. (not necessarily the \"discovery\" paper)",
    "experiments_expected_2017"     : "number of expected experiments - 2017",
    "experiments_expected_2020": "number of expected experiments by 2020",
    "raw_files_size": "size of raw files for 1 experiment (Gb)",
    "raw_files_widely_useful": "Do you expect that the raw files will be widely useful to the general community (on average downloaded more than 1-5 times?)",
    "raw_files_keep_archived": "If no; do you think they should still be kept in archival storage for possible future access?",
    "processed_files_size": "size of processed files for 1 experiment (Gb)",
    "dockerized_software_exists": "Are there (or will there be) opensource software that can be dockerized to create the processed files or will you submit the processed files?",
    "additional_comments": "Additional comments:"
}

export const list = [
    {
      "grant_type": "NOFIC",
      "center_name": "Alber",
      "lab_name": "Lin Chen",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "HiC/TCC",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "Rao et al 2014, Kalhor et al., NBT 2011",
      "experiments_expected_2017": "60",
      "experiments_expected_2020": "300",
      "raw_files_size": "100",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "5",
      "dockerized_software_exists": "opensource",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Alber",
      "lab_name": "Lin Chen",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Crosslinking-TCC",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "in development",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "100",
      "raw_files_size": "100",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "5",
      "dockerized_software_exists": "opensource",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Alber",
      "lab_name": "Lin Chen/John Aitchison/Michael Rout",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Cryo-mill-HiC/GCCP",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "in development",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "100",
      "raw_files_size": "200",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "20",
      "dockerized_software_exists": "opensource",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "Bas van Steensel",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "DamID",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "PMID:20513434*",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "100",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.05",
      "dockerized_software_exists": "in the future there will be a pipeline available",
      "additional_comments": "*  [but DamID-seq instead of DamID-array]"
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "Bas van Steensel",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "TRIP",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "PMID:23953119",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "20",
      "raw_files_size": "12",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "processing software is available (http://trip.nki.nl);*",
      "additional_comments": "*  we are implementing some improvements that we will make available. We will certainly provide processed files."
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "David Gilbert",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "repli-seq",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "method paper soon to be submitted *",
      "experiments_expected_2017": "24",
      "experiments_expected_2020": "200",
      "raw_files_size": "0.3",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.003",
      "dockerized_software_exists": "in the future there will be a pipeline available",
      "additional_comments": "* method paper soon to be submitted (conversion of PMID: 21637205 to sequencing)"
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "Andrew Belmont",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "TSA-seq",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "yes",
      "reference_publication": "TSA-seq, to appear in 2017 *",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "12-24",
      "raw_files_size": "56 (with biolgoical duplicates)",
      "raw_files_widely_useful": "No (Fastq files)",
      "raw_files_keep_archived": "Yes",
      "processed_files_size": "1 (if wig file); 0.3 (bigwig)",
      "dockerized_software_exists": "Will initiall submit the processed files, but working on a standardized pipeline with open software",
      "additional_comments": "* Discovery paper should be published in 2017: TSA-Seq data as part of this paper could be deposited, although the protocol will continue to be developed.  We're not sure what is appropriate here. We are still in the technology stage as the very first paper has not even been published.  We are funded to further develop the technology and I anticipate both the eperimental protocol and the data processing methods will continue to evolve over the course of the grant period.  So we are not close to production stage yet, and we have not even begun to seriously address a quality control pipeline.  Yet the data generated is orthogonal to existing methods and therefore I think will be useful even as the method evolves."
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "Andrew Belmont",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "DNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "1000",
      "experiments_expected_2020": "50000",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted in the near term; may be standardized in the long run.",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Belmont",
      "lab_name": "David Gilbert",
      "data_type": "omics",
      "experiment_category": "single cell omics",
      "experiment_type": "single cell repli-seq",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "yes",
      "reference_publication": "Manuscript to be submitted in 2017",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "NA",
      "raw_files_size": "0.5",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.001",
      "dockerized_software_exists": "Pipeline will be submitted",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Dekker",
      "lab_name": "Job Dekker",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "HI-C 2.0 biorxiv*",
      "experiments_expected_2017": "70",
      "experiments_expected_2020": "200",
      "raw_files_size": "50",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "15",
      "dockerized_software_exists": "create processed files",
      "additional_comments": "* HI-C 2.0: AN OPTIMIZED HI-C PROCEDURE FOR HIGH-RESOLUTION GENOME-WIDE MAPPING OF CHROMOSOME CONFORMATION, bioarxiv, http://biorxiv.org/content/early/2016/11/27/090001"
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Dekker",
      "lab_name": "Job Dekker",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "microC",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "Micro-C XL, Nature Methods, 2016*",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "40",
      "raw_files_size": "50",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "15",
      "dockerized_software_exists": "create processed files",
      "additional_comments": "* Micro-C XL: assaying chromosome conformation from the nucleosome to the entire genome, Nature Methods, 2016"
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Ren",
      "lab_name": "Bing Ren",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C",
      "in_production_stage_standardized_protocol": "Yes",
      "important_to_be_made_available": "n.a.",
      "reference_publication": "Rao et al. 2014",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "100",
      "raw_files_size": "200",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "na",
      "processed_files_size": "10",
      "dockerized_software_exists": "will submit proccessed files",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Ren",
      "lab_name": "Kees Murre",
      "data_type": "imaging",
      "experiment_category": "live cell imaging",
      "experiment_type": "live cell imaging",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "Lucas et al. 2014",
      "experiments_expected_2017": "4",
      "experiments_expected_2020": "20",
      "raw_files_size": "5000",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "1",
      "dockerized_software_exists": "will sbumit the processed files",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Ren",
      "lab_name": "Ana Pombo",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "GAM",
      "in_production_stage_standardized_protocol": "not yet in production stage, but expected start production in 2017",
      "important_to_be_made_available": "yes",
      "reference_publication": "Beagrie et al. 2017",
      "experiments_expected_2017": "1 GAM dataset mESC F123 - collection of 800-2000 sequencing libraries",
      "experiments_expected_2020": "2 GAM datasets: mESC F123 (2500 libraries) and hESC H1 (500 libraries)",
      "raw_files_size": "0.2 Gb per library; 160-500 Gb for mESC F123 dataset and 100 Gb for hESC",
      "raw_files_widely_useful": "no (not raw files, but yes to the positive genomic regions per library)",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "10 kb",
      "dockerized_software_exists": "both; we will submit processed files and GAMtools is available",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Shendure",
      "lab_name": "Jay Shendure/Bill Noble",
      "data_type": "omics",
      "experiment_category": "single cell omics",
      "experiment_type": "Sci Hi-C",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "?",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Shendure",
      "lab_name": "Jay Shendure/Bill Noble",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "in situ DNase Hi-C",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "?",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Shendure",
      "lab_name": "Jay Shendure/Bill Noble",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "ChIP-seq",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "?",
      "experiments_expected_2020": "?",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Shendure",
      "lab_name": "Jay Shendure/Bill Noble",
      "data_type": "omics",
      "experiment_category": "ChIA-PET",
      "experiment_type": "CTCF HiChip",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "?",
      "experiments_expected_2020": "?",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Shendure",
      "lab_name": "Jay Shendure/Bill Noble",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "RNA-seq",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "?",
      "experiments_expected_2020": "?",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Ruan",
      "lab_name": "Yijun Ruan",
      "data_type": "omics",
      "experiment_category": "ChIA-PET",
      "experiment_type": "ChIA-PET",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "Tang et al 2015",
      "experiments_expected_2017": "50",
      "experiments_expected_2020": "500",
      "raw_files_size": "20 gb",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "",
      "processed_files_size": "1",
      "dockerized_software_exists": "yes",
      "additional_comments": ""
    },
    {
      "grant_type": "NOFIC",
      "center_name": "Ruan",
      "lab_name": "Yijun Ruan",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "RICh-PET",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "20",
      "raw_files_size": "20 gb",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "",
      "processed_files_size": "1",
      "dockerized_software_exists": "yes",
      "additional_comments": ""
    },
    /*
    {
      "grant_type": "Imaging",
      "center_name": "Bewersdorf",
      "lab_name": "David Baddeley/Joerg Bewersdorf",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "PALM/STORM",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "python-microscopy.org *",
      "experiments_expected_2017": "",
      "experiments_expected_2020": "",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": "* http://python-microscopy.org/doc/metadata.html, http://python-microscopy.org/doc/SampleDB.html, http://python-microscopy.org/doc/DataFormats.html  Development data: data which will be generated while developing the system but will become obsolete by final proof-of-concept data for publication"
    },
    */
    {
      "grant_type": "Imaging",
      "center_name": "Bewersdorf",
      "lab_name": "David Baddeley/Joerg Bewersdorf",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "PALM/STORM",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "yes",
      "reference_publication": "",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "N/A",
      "raw_files_size": "1000",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "100",
      "dockerized_software_exists": "we will submit the processed files",
      "additional_comments": "Proof-of-concept data: final data used to prove in a publication that the microscope works; data needs to be made available to the public to meet publication requirements"
    },
    /*
    {
      "grant_type": "Imaging",
      "center_name": "Bewersdorf",
      "lab_name": "David Baddeley/Joerg Bewersdorf",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "PALM/STORM",
      "in_production_stage_standardized_protocol": "not yet, but starting summer 2017",
      "important_to_be_made_available": "N/A",
      "reference_publication": "",
      "experiments_expected_2017": "30",
      "experiments_expected_2020": "100/year",
      "raw_files_size": "1000",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "100",
      "dockerized_software_exists": "we will submit the processed files",
      "additional_comments": "Production phase data: biological data recorded with our finished microscope"
    },
    */
    {
      "grant_type": "Imaging",
      "center_name": "Long",
      "lab_name": "Stanley Qi",
      "data_type": "imaging",
      "experiment_category": "live cell imaging",
      "experiment_type": "live cell imaging",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "Yes *",
      "reference_publication": "Chen et al. Cell 2013",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "100",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "1",
      "dockerized_software_exists": "opensource",
      "additional_comments": "* Yes, we are trying to refine the CRISPR imaging of living cells for any non-repeititve loci, and optimize the signal/noise ratio; currently it is mostly refining the protoco. Once the protocol is up, we will apply to stem cells and differentiated cells. At the moment, the data will be of interest to the general public."
    },
    {
      "grant_type": "Imaging",
      "center_name": "Ellenberg",
      "lab_name": "Jan Ellenberg/Jonas Ries",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "single-molecule localization / lattice light-sheet",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "no",
      "experiments_expected_2017": "150",
      "experiments_expected_2020": "1500",
      "raw_files_size": "100",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "no",
      "processed_files_size": "1",
      "dockerized_software_exists": "yes",
      "additional_comments": "we believe we will have small pre-processed example data sets we can give to DCIC to prepare for future larger data sets"
    },
    {
      "grant_type": "Imaging",
      "center_name": "Lam",
      "lab_name": "Kit Lam",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "Confocal microscopy",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "It is in a technology development stage *",
      "reference_publication": "",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "100",
      "raw_files_size": "200",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "1",
      "dockerized_software_exists": "opensource",
      "additional_comments": "It is in a technology development stage, the novel sensor is not yet available, and is currently being developed, tested and optimized."
    },
    {
      "grant_type": "Imaging",
      "center_name": "Liphardt",
      "lab_name": "Moerner",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "3D single-molecule SRM",
      "in_production_stage_standardized_protocol": "yes, but development continues",
      "important_to_be_made_available": "no",
      "reference_publication": "Submitted, and Shechtman et al. Nat. Photon. 10 (2016)",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "20",
      "raw_files_size": "1000",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "no",
      "processed_files_size": "1",
      "dockerized_software_exists": "opensource and processed",
      "additional_comments": ""
    },
    {
      "grant_type": "Imaging",
      "center_name": "Liphardt",
      "lab_name": "Moerner/Liphardt",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "4D single-particle tracking",
      "in_production_stage_standardized_protocol": "yes, but development continues",
      "important_to_be_made_available": "no",
      "reference_publication": "Shechtman et al. Nano Lett. 15, (2015) Backlund et al. Mol. Biol. Cell 25 (2014)",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "20",
      "raw_files_size": "10",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "no",
      "processed_files_size": "0.5",
      "dockerized_software_exists": "opensource and processed",
      "additional_comments": ""
    },
    {
      "grant_type": "Imaging",
      "center_name": "Liphardt",
      "lab_name": "Liphardt/Moerner",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "Simultaneous tracking of ~100 Histones*",
      "in_production_stage_standardized_protocol": "yes, but development continues",
      "important_to_be_made_available": "yes",
      "reference_publication": "in preperation",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "80",
      "raw_files_size": "1",
      "raw_files_widely_useful": "marginally useful",
      "raw_files_keep_archived": "if possible",
      "processed_files_size": "0.1",
      "dockerized_software_exists": "opensource and processed",
      "additional_comments": "* Simultaneous tracking of ~100 Histones with various perturbagens (epigenetics, mechanics, topoisomerase, cell cycle)  * in prep: Ghosh et al., ArrayGN-dCAS9-based optical tagging of arbitrary, non-repetitive loci in the human genome (2017)"
    },
    {
      "grant_type": "Imaging",
      "center_name": "Liphardt",
      "lab_name": "Liphardt/Moerner/Qi",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "Multiple locus tracking with dCAS9/ArrayGN (MUC1, VIM, CK14)",
      "in_production_stage_standardized_protocol": "yes, but development continues",
      "important_to_be_made_available": "yes",
      "reference_publication": "",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "40",
      "raw_files_size": "1",
      "raw_files_widely_useful": "marginally useful",
      "raw_files_keep_archived": "if possible",
      "processed_files_size": "0.1",
      "dockerized_software_exists": "opensource and processed",
      "additional_comments": ""
    },
    {
      "grant_type": "Imaging",
      "center_name": "O'Shea",
      "lab_name": "Clodagh O'Shea/Mark Ellisman",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "EM Tomography",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "15",
      "raw_files_size": "10-100TB per year in yr1 (to scale in subsequent years)",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "",
      "processed_files_size": "10-100TB per year in yr1 (to scale in subsequent years)",
      "dockerized_software_exists": "imod, imagej, and TXBR are available as opensource tools",
      "additional_comments": ""
    },
    {
      "grant_type": "Imaging",
      "center_name": "Singer",
      "lab_name": "Coleman/Rob Singer",
      "data_type": "imaging",
      "experiment_category": "SRM",
      "experiment_type": "live Cell SRM (widefield)",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "yes (see additional comments below)",
      "reference_publication": "Chen et al. Cell, 2014 PMID: 24630727",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "50",
      "raw_files_size": "10-20",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "1",
      "dockerized_software_exists": "submitted",
      "additional_comments": "This type of data will be a mixture of one-off, consortia microscope evaluation and biological experiments. One-off technology development doesn't need to be stored but microscope evaluation and biological experiments will need to be stored"
    },
    {
      "grant_type": "Imaging",
      "center_name": "Singer",
      "lab_name": "Coleman/Rob Singer",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "RNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "Senecal et. al. Cell Reports, 2014 PMID: 24981864",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "50",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Brangwynne",
      "lab_name": "Cliffard Brangwynne",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "Confocal microscopy",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "No",
      "reference_publication": "Shin et.al. 2017",
      "experiments_expected_2017": "500",
      "experiments_expected_2020": "1500",
      "raw_files_size": "2",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "Yes",
      "processed_files_size": "2",
      "dockerized_software_exists": "N/A",
      "additional_comments": "I do not believe that the type of image data that we are generating will be useful and/or interpretable to the broader community as raw data. However, we are of course happy to share raw data with members of the consortium who are interested in it."
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Gerace",
      "lab_name": "Larry Gerace",
      "data_type": "proteomics",
      "experiment_category": "proteomics",
      "experiment_type": "proteomics",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "no",
      "reference_publication": "",
      "experiments_expected_2017": "80",
      "experiments_expected_2020": "320",
      "raw_files_size": "3",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "5",
      "dockerized_software_exists": "They will be submitted whenever necessary",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Groudine",
      "lab_name": "Joan Ritland",
      "data_type": "imaging",
      "experiment_category": "live cell imaging",
      "experiment_type": "live widefield microscopy",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "",
      "experiments_expected_2017": "30",
      "experiments_expected_2020": "200",
      "raw_files_size": "5",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "5",
      "dockerized_software_exists": "opensource",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Groudine",
      "lab_name": "Joan Ritland",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "DNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "Strongin et al., Nucleus, 2015",
      "experiments_expected_2017": "50",
      "experiments_expected_2020": "200",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.05",
      "dockerized_software_exists": "opensource",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Groudine",
      "lab_name": "David Scalzo/Joan Ritland",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "DamID",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "Guelen et al., Nature, 2008",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "20",
      "raw_files_size": "1",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "opensource",
      "additional_comments": "All omics data gathering (except for DAM-ID) will be in collaboration with omics-based 4DN groups, who will submit the data"
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Guttman",
      "lab_name": "Sonja Hess",
      "data_type": "proteomics",
      "experiment_category": "proteomics",
      "experiment_type": "Middle Down Histone Analysis",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "PMID: 26176279",
      "experiments_expected_2017": "50",
      "experiments_expected_2020": "250",
      "raw_files_size": "0.8",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Guttman",
      "lab_name": "Mitch Guttman",
      "data_type": "proteomics",
      "experiment_category": "proteomics",
      "experiment_type": "RAP-MS",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "PMID: 25915022",
      "experiments_expected_2017": "50",
      "experiments_expected_2020": "250",
      "raw_files_size": "2",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "0.1",
      "dockerized_software_exists": "submitted",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Kaufman",
      "lab_name": "Paul Kaufman",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "NAD-seq (deep sequencing of purified nucleoli)",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "in preparation",
      "experiments_expected_2017": "32",
      "experiments_expected_2020": "160",
      "raw_files_size": "15",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "15",
      "dockerized_software_exists": "create processed files",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Kaufman",
      "lab_name": "Paul Kaufman",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "DNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "PMID: 11978004",
      "experiments_expected_2017": "72",
      "experiments_expected_2020": "480",
      "raw_files_size": "100 cells x 0.3 Gb = 30Gb",
      "raw_files_widely_useful": "No",
      "raw_files_keep_archived": "Yes",
      "processed_files_size": "1 Gb",
      "dockerized_software_exists": "create processed files",
      "additional_comments": "* 12 probes per cell type = 72"
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Kaufman",
      "lab_name": "Thoru Pederson",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "CRISPR-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "PMID: 25713381",
      "experiments_expected_2017": "72",
      "experiments_expected_2020": "480",
      "raw_files_size": "100 cells x 0.3 Gb = 30Gb",
      "raw_files_widely_useful": "No",
      "raw_files_keep_archived": "Yes",
      "processed_files_size": "1 Gb",
      "dockerized_software_exists": "create processed files",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Lomvardas",
      "lab_name": "Lewis Brown",
      "data_type": "proteomics",
      "experiment_category": "proteomics",
      "experiment_type": "proteomics",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "No",
      "reference_publication": "PMID: 24439385",
      "experiments_expected_2017": "0",
      "experiments_expected_2020": "140",
      "raw_files_size": "20",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "We will deposit raw data from publications at https://chorusproject.org",
      "processed_files_size": "0.005",
      "dockerized_software_exists": "MS Excel",
      "additional_comments": "proteomics experimental work does not start until year 3, which begins 9/1/17"
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Lomvardas",
      "lab_name": "Carolyn Larabell",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "Soft-X Ray Tomography/correlative Cryo-Fluorescence",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "No",
      "reference_publication": "PMID:27630123",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "50",
      "raw_files_size": "500",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "yes, we have the ability to store the data in an accessible fashion at LBNL",
      "processed_files_size": "5000",
      "dockerized_software_exists": "In preparation",
      "additional_comments": ""
    },
    {
      "grant_type": "Nuclear Bodies and Compartments",
      "center_name": "Lomvardas",
      "lab_name": "Stavros Lomvardas",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C",
      "in_production_stage_standardized_protocol": "yes/No*",
      "important_to_be_made_available": "yes",
      "reference_publication": "PMID: 26619908",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "50",
      "raw_files_size": "600",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "600",
      "dockerized_software_exists": "No",
      "additional_comments": "*  (yes referce to the fact that we are cuunretly using estblished HiC protocols to generate a baseline for comparisons with the methodological improvments we proposed to perform"
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Fraser",
      "lab_name": "Peter Fraser/Amos Tanay",
      "data_type": "omics",
      "experiment_category": "single cell omics",
      "experiment_type": "Single-cell HiC",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "",
      "reference_publication": "Nagano et al. 2016",
      "experiments_expected_2017": "3500",
      "experiments_expected_2020": "10000",
      "raw_files_size": "0.0006",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.5",
      "dockerized_software_exists": "will submit",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Guttman",
      "lab_name": "Mitch Guttman",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "SPRITE RNA-DNA",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "Quinodoz, et al 2017 (in prep)",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "100",
      "raw_files_size": "200",
      "raw_files_widely_useful": "no (processed more useful), these sizes are of zipped data, unzipped is 500",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "15",
      "dockerized_software_exists": "submitted for now, standardize in future",
      "additional_comments": "in development"
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Guttman",
      "lab_name": "Mitch Guttman",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "SPRITE DNA",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes",
      "reference_publication": "Quinodoz, et al 2017 (in prep)",
      "experiments_expected_2017": "15",
      "experiments_expected_2020": "80",
      "raw_files_size": "200",
      "raw_files_widely_useful": "no (processed more useful), these sizes are of zipped data, unzipped is 500",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "15",
      "dockerized_software_exists": "submitted for now, standardize in future",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Guttman",
      "lab_name": "Rustem Ismagilov",
      "data_type": "omics",
      "experiment_category": "single cell omics",
      "experiment_type": "SPRITE Single Cell",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "no",
      "reference_publication": "Quinodoz, et al 2017 (in prep)",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "100",
      "raw_files_size": "200",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "15",
      "dockerized_software_exists": "submitted for now, standardize in future",
      "additional_comments": "in development"
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Guttman",
      "lab_name": "Mitch Guttman/Rustem Ismagilov",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "DNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "for validation for results, but still useful to post if general interest",
      "reference_publication": "",
      "experiments_expected_2017": "30",
      "experiments_expected_2020": "150",
      "raw_files_size": "42",
      "raw_files_widely_useful": "no",
      "raw_files_keep_archived": "not sure",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "no",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Lieberman-Aiden",
      "lab_name": "Erez Lieberman Aiden",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "COLA",
      "in_production_stage_standardized_protocol": "No",
      "important_to_be_made_available": "No",
      "reference_publication": "Darrow & Huntley et al. PNAS 2016",
      "experiments_expected_2017": "5",
      "experiments_expected_2020": "30",
      "raw_files_size": "1 Gb",
      "raw_files_widely_useful": "No",
      "raw_files_keep_archived": "As DCIC prefers. We are happy to do this on our own.",
      "processed_files_size": "1 Gb",
      "dockerized_software_exists": "No, we will submit processed files",
      "additional_comments": "There is published COLA support in the latest version of Juicer, but we may modify the pipeline to support this sequencing modality."
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Lieberman-Aiden",
      "lab_name": "Erez Lieberman Aiden",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C (karyotype assessment)",
      "in_production_stage_standardized_protocol": "No",
      "important_to_be_made_available": "No. *",
      "reference_publication": "Lieberman-Aiden & Van Berkum et al., Science 2009",
      "experiments_expected_2017": "10",
      "experiments_expected_2020": "Unknown",
      "raw_files_size": "1Gb",
      "raw_files_widely_useful": "No",
      "raw_files_keep_archived": "No",
      "processed_files_size": "1Gb",
      "dockerized_software_exists": "",
      "additional_comments": "* The goal at present is to assess the usability of Hi-C for identifying karyotypic instabilities in 4DN cel cultures  This could be important to archive if we decide to incorporate Hi-C into the consortium's QC pipeline"
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Lieberman-Aiden",
      "lab_name": "Erez Lieberman Aiden",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C (loop resolution)",
      "in_production_stage_standardized_protocol": "",
      "important_to_be_made_available": "",
      "reference_publication": "Rao & Huntley et al Cell 2014",
      "experiments_expected_2017": "",
      "experiments_expected_2020": "",
      "raw_files_size": "",
      "raw_files_widely_useful": "",
      "raw_files_keep_archived": "",
      "processed_files_size": "",
      "dockerized_software_exists": "",
      "additional_comments": "We may do this as needed as part of the focused inter-center efforts on specific cell lines and loci. However, we have no definite plans to do such maps as part of our 4DN effort."
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Lis",
      "lab_name": "John Lis",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "HiC",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "yes.",
      "reference_publication": "Rao et al (2014) PMID:25497547",
      "experiments_expected_2017": "8",
      "experiments_expected_2020": "8",
      "raw_files_size": "20-50 Gb",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "1 Gb",
      "dockerized_software_exists": "opensource",
      "additional_comments": "This is in part a set of controls for our technology development project. However, the data will be of use and will be made available to the general community in the coming years."
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Lis",
      "lab_name": "John Lis",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Distance HiC",
      "in_production_stage_standardized_protocol": "no",
      "important_to_be_made_available": "yes",
      "reference_publication": "None",
      "experiments_expected_2017": "4",
      "experiments_expected_2020": "40",
      "raw_files_size": "20-50 Gb",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "1 Gb",
      "dockerized_software_exists": "yes, we will opensource our pipeline when the technology is developed",
      "additional_comments": "* There is no similar data sets. This is new technology development."
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Raj",
      "lab_name": "Arjun Raj",
      "data_type": "imaging",
      "experiment_category": "other imaging",
      "experiment_type": "RNA FISH with expansion microscopy",
      "in_production_stage_standardized_protocol": "No",
      "important_to_be_made_available": "No",
      "reference_publication": "None",
      "experiments_expected_2017": "50",
      "experiments_expected_2020": "200",
      "raw_files_size": "10-100",
      "raw_files_widely_useful": "No",
      "raw_files_keep_archived": "Yes",
      "processed_files_size": "0.1",
      "dockerized_software_exists": "Submit processed files",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Raj",
      "lab_name": "Jennifer Phillips-Cremins",
      "data_type": "omics",
      "experiment_category": "Capture-Hi-C",
      "experiment_type": "5C",
      "in_production_stage_standardized_protocol": "Yes",
      "important_to_be_made_available": "No",
      "reference_publication": "http://www.cell.com/cell-stem-cell/pdf/S1934-5909(16)30047-9.pdf",
      "experiments_expected_2017": "20",
      "experiments_expected_2020": "200",
      "raw_files_size": "100",
      "raw_files_widely_useful": "Yes",
      "raw_files_keep_archived": "yes",
      "processed_files_size": "10",
      "dockerized_software_exists": "Submit processed files; code will be available",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Raj",
      "lab_name": "Gerd Blobel",
      "data_type": "omics",
      "experiment_category": "Hi-C",
      "experiment_type": "Hi-C",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "no",
      "reference_publication": "http://www.sciencedirect.com/science/article/pii/S0092867413005291",
      "experiments_expected_2017": "8",
      "experiments_expected_2020": "???",
      "raw_files_size": "100",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted in the near term; may be standardized in the long run.",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Raj",
      "lab_name": "Gerd Blobel",
      "data_type": "omics",
      "experiment_category": "other omics",
      "experiment_type": "ChIP-seq",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "no",
      "reference_publication": "http://www.sciencedirect.com/science/article/pii/S0092867413005291",
      "experiments_expected_2017": "8",
      "experiments_expected_2020": "???",
      "raw_files_size": "100",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted in the near term; may be standardized in the long run.",
      "additional_comments": ""
    },
    {
      "grant_type": "Nucleomics Tools",
      "center_name": "Raj",
      "lab_name": "Gerd Blobel",
      "data_type": "imaging",
      "experiment_category": "DNA-FISH",
      "experiment_type": "DNA-FISH",
      "in_production_stage_standardized_protocol": "yes",
      "important_to_be_made_available": "no",
      "reference_publication": "http://www.sciencedirect.com/science/article/pii/S0092867413005291",
      "experiments_expected_2017": "8",
      "experiments_expected_2020": "???",
      "raw_files_size": "100",
      "raw_files_widely_useful": "yes",
      "raw_files_keep_archived": "N/A",
      "processed_files_size": "0.01",
      "dockerized_software_exists": "submitted in the near term; may be standardized in the long run.",
      "additional_comments": ""
    }
];